export default __webpack_public_path__ + "static/media/shelly.44efc73d.png";